import React from "react";

import useApproveBondsEndorsementHandlers from "../hooks/useApproveBondsEndorsementHandlers";
import { approveBondsEndorsementDialogPropTypes } from "./bondEndorsementDialogPropTypes";
import BondEndorsementDialog from "./BondEndorsementDialog";

export default function ApproveBondsEndorsementDialog(props) {
  const { handleReleaseRider, handleSubmitEndorsementRequest } =
    useApproveBondsEndorsementHandlers(props);
  return (
    <BondEndorsementDialog
      variant="approve"
      {...props}
      handleReleaseRider={handleReleaseRider}
      handleSubmitEndorsementRequest={handleSubmitEndorsementRequest}
    />
  );
}

ApproveBondsEndorsementDialog.propTypes = approveBondsEndorsementDialogPropTypes;
